"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logIconButtonErrors = void 0;
/**
 * Logs errors related to IconButton.
 *
 * @param {string} size The size of the IconButton.
 * @param {object} IconComponent The IconComponent object.
 * @param {string} IconComponent.displayName The display name of the IconComponent.
 * @returns {void}
 */
var logIconButtonErrors = exports.logIconButtonErrors = function logIconButtonErrors(size, IconComponent) {
  if (!IconComponent) {
    console.error('An Icon Button was rendered with no icon.');
    return null;
  }
  var iconName = IconComponent === null || IconComponent === void 0 ? void 0 : IconComponent.displayName;
  if (size === 'small' && !(iconName !== null && iconName !== void 0 && iconName.match(/24px/i))) {
    console.error("".concat(iconName, ", was passed into a 'small' Icon Button. A small Icon Button should be rendered with a 24px icon."));
  }
  if (size === 'medium' && !(iconName !== null && iconName !== void 0 && iconName.match(/24px/i))) {
    console.error("".concat(iconName, ", was passed into a 'medium' Icon Button. A medium Icon Button should be rendered with a 24px icon."));
  }
  if (size === 'large' && !(iconName !== null && iconName !== void 0 && iconName.match(/32px/i))) {
    console.error("".concat(iconName, ", was passed into a 'large' Icon Button. A large Icon Button should be rendered with a 32px icon."));
  }
};